import React from 'react';
import Logo from 'src/assets/img/CI&TLogo.png';
import './style.scss';

/**
 * Footer component - contains only the CI&T logo.
 *
 * @returns {JSX.Element} The Footer component.
 * @example
 *  <Footer />
 */
function Footer() {
    return (
        <div className="app-footer">
            <div className="logo-container">
                <img src={Logo} alt="CI&T Logo" />
            </div>
        </div>
    )
}

export default Footer;
